import { Box, Divider, Grid, Typography } from "@mui/material";
import React from "react";
import styles from "./services.module.scss";

const nutritionC = () => {
  return (
    <Typography className={styles.details}>
      <ol style={{margin:0}}>
        <li>
          Plan a balanced Meals which includes one food from each food group-
          Dairy; Vegetables; Fruits; Grains and Protein, Adequate Hydration.
        </li>
        <li>
          Eating nutritious foods in the right amounts can help keep you
          healthy. Many illnesses, such as heart disease, obesity, high blood
          pressure, type 2 diabetes, and osteoporosis, can be prevented or
          controlled with dietary changes and exercise.
        </li>
        <li>Plenty green leafy vegetables, beans, soy, lentils for protein</li>
        <li>
          Eat varieties of food, eat bright colored veggies and fruits.
          Apricots, avocado, Banana, Beans (dried), Broccoli, Brussel sprouts,
          Cantaloupe, Carrots, Greens,Honeydew, Milk, Mushrooms, Oranges,Orange
          juice, Potato, Prunes, Prune juice, Raisins, Spinach, Strawberries,
          Sweet potato,Tomato,Tomato juice, Winter squash.
        </li>
        <li>
          High in calcium -Cheeses and dairy products (low fat if watching
          cholesterol, but dairy products are best calcium source as they are
          easily absorbed into the body), milk, legumes,salmon, sardines (with
          bones), tofu, yogurt, almonds, broccoli, and dark leafy vegetables
          '(kale or collard greens)'
        </li>
        <li>Adequate vitamin intake (supplement if needed)</li>
        <li>Less of fried food, less desserts</li>
        <li>
          Overall, eat in moderation, Avoid large amounts of carbohydrates but
          OK in moderation. Supplement rice with oats, quinoa.
        </li>
        <li>
          Learn to read food labels, as serving size may be small & people can
          mistake how much calories/fat/ minerals in a single serving has.
          Maintain appropriate weight, avoid obesity or fragility
          (malnourishment).
        </li>
        <li>
          Eating mindfully helps better digestion. chew and eat slowly helps to
          break down carbs and fats.
        </li>
        <li>
          Adequate fiber consumption improves digestion and bowel function.
        </li>
        <li>
          Fluid intake/Hydration-- It is easy to get dehydrated. Make sure
          you’re drinking about 8 - 10 eight-ounce glasses of water a day. Check
          with your Physician if you have cardiac or renal issues and need fluid
          restriction. -Replace sugary drinks with water.
        </li>
        <li>
          Needs to be adapted to suit an individual's own lifestyle, daily
          routine and nutritional requirements.
        </li>
      </ol>
    </Typography>
  );
};

const activityD = () => {
  return (
    <Typography className={styles.details}>
      <ol style={{margin:0}}>
        <li>
          Physical: Exercises for improving muscle tone, walking for
          cardiovascular fitness, balance is important.
        </li>
        <li>
          Keep moving a sedentary lifestyle is associated with constipation,
          Exercise regularly in moderation.
        </li>
        <li>
          Do something to keep fit each day something you enjoy that maintains
          strength, balance and flexibility and promotes cardiovascular health.
        </li>
        <li>
          Physical activity helps you stay at a healthy weight, prevent or
          control illness, sleep better, reduce stress, avoid falls and feel
          better also
        </li>
        <li>
          Mobility / yoga / Exercising (whatever physical exercise you enjoy
          doing)/ a walk outdoors.
        </li>
        <li>
          Stress isn’t inherently bad, but too much for too long is bad for
          health.
        </li>
        <li>
          Focus on properly managing stress by: Setting boundaries, practicing
          meditation, deep breathing.
        </li>
        <li>
          Try relaxation / meditation / soft music / reading or deep breathing
          as a means of coping.
        </li>
        <li>
          Make time for friends and social contacts and fun. Learn the role of
          positive thinking.
        </li>
        <li>
          Energy conservation- Pace yourself, get enough rest, make things
          simple.
        </li>
        <li>
          Sleep problems can affect your quality of life and can contribute to
          falls, injuries, and other health problems. Limited sleeping,
          sun-downing are common.
        </li>
      </ol>
    </Typography>
  );
};

const cognitionE = () => {
  return (
    <Typography className={styles.details}>
      <ol style={{margin:0}}>
        <li>
          Social interaction/ Social activity in local senior centers, community
          activities and group activities with friends should be done and
          encouraged, isolation should be avoided. Dementia, is a memory problem
          significant enough to affect ability to carry out one’s daily tasks.
        </li>
        <li>
          By age 50, most people notice changes to their vision, including a
          gradual decline in the ability to see small print or focus on close
          objects. Common eye problems that can impair vision include cataracts
          and glaucoma.
        </li>
        <li>
          Hearing loss occurs commonly with aging, often due to exposure to loud
          noise.
        </li>
        <li>
          Hearing is often impaired as we age all efforts to keep hearing sound,
          news conversation, music should be encouraged to avoid cognitive
          decrease.
        </li>
        <li>Puzzles/ games/ Art and crafts keep eye hand coordination well.</li>
        <li>
          Regular Senior activities, Group periodic socialization, Volunteering,
          Arts/crafts, Spiritual discussions, group walking, keeping track and
          watching out for each other are helpful tools.
        </li>
        <li>
          Mental Activity (Spiritual Yoga, Meditation, Chanting, Laughter,
          Memory Educational activities, etc)
        </li>
      </ol>
    </Typography>
  );
};
const medicationG = () => {
  return (
    <Typography className={styles.details}>
      Tips for not missing dose? Weekly containers AM, Noon, PM Storage
      specially out of reach children, Cool dark place, Narcotics security.
      Check medication expiration dates on all prescription and over-the-counter
      medications – and follow all directions. Review side effects of any new
      medications with your physician such as causing drowsiness that will
      increase risk of falls, also impair driving ability. Over the counter
      supplements – may have interactions with prescription drugs should be
      consumed after discussing with Primary provider
    </Typography>
  );
};

const endOfIssuesH = () => {
  return (
    <Typography className={styles.details}>
      <ol style={{margin:0}}>
        <li>
          Advance Directives, Power of Attorney for Health care decisions,
          specially your directive to your PCP end of Life, Long term care
          insurance.
        </li>
        <li>
          Sustaining measures signed statement (POLST), Burial Insurance, Estate
          Will. etc.,
        </li>
        <li>
          End of Life planning-by completing Advance directives, choose who you
          want make medical decisions for you if you are unable to do so-appoint
          a trusted family member, let them know your wishes.
        </li>
        <li>
          There is California State Form called POLST- Physician Orders for Life
          Sustaining Treatment- Discuss with your physician about completing
          this form that needs your physician’s signature & your signature,
          after making choices.
        </li>
      </ol>
    </Typography>
  );
};

const immunizationRequirement = () => {
  return (
    <Typography className={styles.details}>
      <ol style={{margin:0}}>
        <li>Annual Flu Vaccine.</li>
        <li>
          Pneumonia vaccination 65 years and older or younger with chronic
          health conditions like Diabetes, Lung disease. types of pneumonia
          vaccine are recommended at one year apart-check with your physician
          about how and when to take it.
        </li>
        <li>Shingles Vaccine at 60 years of age, once a life time.</li>
        <li>T-Dap vaccine booster every 10 years.</li>
      </ol>
    </Typography>
  );
};
const safetyRequirements = () => {
  return (
    <Typography className={styles.details}>
      <ol style={{margin:0}}>
        <li>
          Fall prevention by exercising to keep fit, removing clutter from the
          floor at home, using assistive devices such as cane or walker for
          stability,
        </li>
        <li>
          Personal factors, which include muscle weakness, balance problems,
          limited vision and certain medications increase risk for falling. Many
          falls happen when you lose your balance. Exercising regularly and
          rising slowly after eating, sitting or lying down can help avoid
          dizziness and loss of balance.
        </li>
        <li>
          Environmental factors, which include home hazards such as loose rugs,
          poor lighting (especially on stairs) and a lack of stair railings or
          grab bars in the bathroom.
        </li>
        <li>
          Consider wearing an alarm device in case you fall and cannot get up on
          your own.
        </li>
        <li>
          Get an eye exam at least once a year. You may be wearing the wrong
          glasses or have a condition that limits your vision.
        </li>
        <li>
          Installing secure handrails and bright lights with switches at the top
          and bottom of stairways.
        </li>
        <li>
          Repairing loose or uneven steps, checking stairs for worn or loose
          carpeting and installing anti-slip treads.
        </li>
        <li>
          Always wearing shoes with traction and making sure throw rugs are
          placed over rug liners with non-skid backing so that you avoid falls
          throughout the house.
        </li>
        <li>
          Installing grab bars for the toilet, bathtub and/or shower, and using
          non-slip mats or decals on ceramic surfaces both inside and outside
          the tub.
        </li>
        <li>
          Installing nightlights in areas you frequent at night. Also, consider
          keeping a flashlight near your bed.
        </li>
        <li>
          Storing frequently-used items on lower shelves in the kitchen to limit
          the use of stools or step-ladders. If you must use a step stool, use
          one with a bar to hold onto.
        </li>
      </ol>
    </Typography>
  );
};
const skinCare = () => {
  return (
    <Typography className={styles.details}>
      As we age, our skin grows thinner; it becomes drier and less elastic.
      Wrinkles appear, and cuts and bruises take longer to heal. Be sure to
      protect your skin from the sun. Too much sun and ultraviolet rays can
      cause skin cancer
    </Typography>
  );
};

const detailSummary = () => {
  return (
    <Typography className={styles.details}>
      These are general guidelines and information only, collected and compiled
      by reading journals & updates. The information listed below are obtained
      from sources believed to be reliable. HCCC and its affiliates/volunteers
      indemnifies itself and assume no liability in connection with the
      information or the provided safety suggestions. The recommendations
      provided are general in nature; unique circumstances may require
      implementation of specific management strategies.
      <br /><br />
      Please discuss with your medical provider and consult with your family for
      additional guidance
    </Typography>
  );
};

const HealthAndWellness = () => {
  return (
    <Box className={styles.goldenAgersActivityConatiner}>
      <Typography className={styles.mainheadings} sx={{marginBottom:"16px"}}>
        General Information on Health Maintenance for Seniors.
      </Typography>
      <Typography >
        A.Health Care Maintenance: PCP Medical Provider for Annual/Periodical
        visits.
      </Typography>
      <Typography className={styles.details}>
        B.Regular dental checkups. Daily brushing and flossing
      </Typography>
      <Box className={styles.singleSection}>
        <Typography>
         <b>C.Nutrition guide-lines:</b> 
        </Typography>
        {nutritionC()}
      </Box>
      <Box className={styles.singleSection}>
        <Typography>
          <b>D.Activity / mobility / sleep/ stress:</b>
        </Typography>
        {activityD()}
      </Box>
      <Box className={styles.singleSection}>
        <Typography>
          <b>E.Cognition/Vision and Hearing Management:</b>
        </Typography>
        {cognitionE()}
      </Box>
      <Box className={styles.singleSection}>
        <Typography >
          <b>F.Preventative Care:</b>
        </Typography>
        <Typography>
          <b>Immunization requirements</b> Recommended Immunization 2017:{" "}
          {immunizationRequirement()}
        </Typography>
        <Typography>
          <b>
            Safety Tips: Prevention Injuries:</b> Fall /Safety/ cane/Walker support/
            Bath Room Design
          
          {safetyRequirements()}
        </Typography>
        <Typography>
          <b> Skin care:</b>
          {skinCare()}
        </Typography>
      </Box>
      <Box className={styles.singleSection}>
        <Typography ><b>G. Medications:</b></Typography>
        {medicationG()}
      </Box>
      <Box className={styles.singleSection}>
        <Typography><b> H.End of Life Issues:</b>
         
        </Typography>
        {endOfIssuesH()}
      </Box>
      <Divider sx={{marginBottom:"16px"}} />
      <Box className={styles.singleSection}>{detailSummary()}</Box>
    </Box>
  );
};

export default HealthAndWellness;
